module.exports = __webpack_public_path__ + "media/icons/checkmark-white-50da3bb2.png";